export default [
  {
    name: 'InfrastructureDictionary.List',
    path: 'infrastructure',
    component: () => import('./components/infrastructure/List')
  },
  {
    name: 'InfrastructureDictionary.Edit',
    path: 'infrastructure/:id(\\d+)?/edit',
    props: true,
    component: () => import('./components/infrastructure/Edit')
  },
  {
    name: 'Advantages.List',
    path: 'advantages',
    component: () => import('./components/advantages/List')
  },
  {
    name: 'Advantages.Edit',
    path: 'advantages/:id(\\d+)?/edit',
    props: true,
    component: () => import('./components/advantages/Edit')
  }
]
